'use client';
import Image from 'next/image';
import React, { useState } from 'react';

const TabbedSection = ({ title, subtitle, description, image, tabsData, color, textcolor, active, activetext }) => {
    const [activeTab, setActiveTab] = useState(tabsData?.[0]?.key || '');

    return (
        <section className={`${color} text-${textcolor} mt-20 mb-20`}>
            <div className="container mt-5">
                <div className="text-center">
                    <span className="sec-subtile-6">{subtitle}</span>
                    <h2 className="py-3">{title}</h2>
                    <p className="py-3">{description}</p>
                </div>

                <div className="row mt-5">
                    {/* Tab Buttons */}
                    <div className="col-md-3 col-sm-12 py-2">
                        <div className="d-flex flex-column align-items-centerw- 100 h-100">
                            {tabsData.map(tab => (
                                <button
                                    key={tab.key}
                                    className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === tab.key ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'
                                        }`}
                                    onClick={() => setActiveTab(tab.key)}
                                >
                                    <h3 className='text-[18px]'>{tab.title}</h3>
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div className="col-md-9 col-sm-12">
                        {tabsData.map(tab =>
                            activeTab === tab.key ? (
                                <section key={tab.key}>
                                    {/* 
                                    {tab.title && tab.description && <div className="mb-3">
                                        <h3>{tab.title}</h3>
                                        <p>{tab.description}</p>
                                    </div>} */}

                                    <div className="row">
                                        {tab.features.map((feature, i) => (
                                            <>
                                                <div key={i} className="col-md-8 col-sm-12 p-3 mb-3 rounded-lg">
                                                    <span className="workflow__title-6 !py-4 ">{tab.title}</span>
                                                    <p>{feature.desc}</p>
                                                    {feature.points && (
                                                        <ul className="py-3 pl-3 list-disc list-inside">
                                                            {feature.points.map((point, idx) => (
                                                                <li key={idx} className='p-1'>+ {point}</li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                                <div className='col-md-4'>
                                                    <Image
                                                        src={image}
                                                        alt={title}
                                                        className='rounded-lg'
                                                        width={800}
                                                        height={900}
                                                    />
                                                </div>
                                            </>
                                        ))}
                                    </div>

                                </section>
                            ) : null
                        )}
                    </div>


                </div>
            </div>
        </section>
    );
};

export default TabbedSection;
